import { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";

import { UsageOverview } from "./pages/UsageOverview";
import { SelectSubscription } from "./pages/SelectSubscription";

export const Usage: FunctionComponent = () => {
	return (
		<Routes>
			<Route element={<UsageOverview />} path="/" />
			<Route element={<SelectSubscription />} path="/select" />
		</Routes>
	);
};
